import React, { useEffect, useState } from "react";
import Modal from "react-modal"
import { adminServices } from "../../services/AdminServices";
import InputText1 from '../InputText1';
import InputText2 from '../InputText2';
import Button from '../Button';
import LoadingModal from "../LoadingModal";
import Dropdown from "../Dropdown";
const customStyles = { 
    overlay: { 
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1000,
    }, 
    content: {
        width: '90%', 
        maxWidth: '500px',
        margin: 'auto', 
        padding: '30px',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        overflow: 'auto',
        maxHeight: '65vh'
    },
 };

const CategoryFormComponent = ({show,onClose,data = null, onAfterSubmit, onError})=>{
    const [category, setCategory] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(null);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState("add");

    useEffect(()=>{
        if(data){
            setMode("edit");
            setCategory(data.category);
            setDescription(data.description);
            setStatus(data.status_id);
        }
        else{
            setMode("add");
            setCategory("");
            setDescription("");
            setStatus(1);
            setValidated(false);
        }
    },[data]);

    const validateForm = () => {
        if(category == "" || description == "" || status == null){
            return false;
        }

        return true;
    }

    const handleSubmit = async () => {
        if(validateForm()){
            setLoading(true);
            let payload = {
                category: category,
                description: description,
                statusId: status
            }

            if(data == null){
                adminServices.postData('ServiceCategories',payload).then((response)=>{
                    setLoading(false);
                    if(response.status == 201 || response.status == 200){
                        onClose();
                        onAfterSubmit();
                    }
                }).catch((error)=>{
                    setLoading(false);
                    onError();
                    onClose();
                });
            }
            else{
                payload = data;
                data.category = category;
                data.description = description;
                data.statusId = status;
                payload.regDate = data.reg_date;
                adminServices.updateData('servicecategories/' + data.id,payload).then((response)=>{
                    if(response.status == 201 || response.status == 204){
                        setLoading(false);
                        onClose();
                        onAfterSubmit();
                    }
                }).catch((error)=>{
                    setLoading(false);
                    onError();
                    onClose();
                });
            }
            
        }
        else{
            setValidated(true);
        }
    }

    return (
        <Modal
            
            isOpen={show}
            shouldCloseOnEsc={false} 
            shouldCloseOnOverlayClick={false}
            style={customStyles}
            onRequestClose={onClose}
        >
        <LoadingModal show={loading} message={"Saving data..."} />
         <div style={{display:"flex",justifyContent:'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid #e0e0e0'}}>
                <h3 style={{margin: 0, fontSize: '18px', fontWeight: '600', color: '#333'}}>Category Management</h3>
                <button style={{backgroundColor:'transparent',
                    border:'none',
                    color:'#999',
                    cursor: 'pointer',
                    padding: '0',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    transition: 'color 0.2s',
                    '&:hover': {color: '#333'}}}
                    onClick={onClose}
                    title="Close"
                    >
                        ×
                    </button>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '20px'}}>
                <InputText1 title={"Category"} value={category} onChange={(e)=>{ setCategory(e.target.value) }} />
                <InputText1 title={"Description"} value={description} onChange={(e)=>{ setDescription(e.target.value) }} />
                <Dropdown title={"Status"} value={status} onChange={(e)=>{ 
                    if(e.target.value!= null){
                        let value = parseInt(e.target.value);
                        setStatus(value);
                    }
                    
                }} 
                    data= {[
                        {value:null,label:"Please select status"},
                        {value:1,label:"Active"},
                        {value:0,label:"Inactive"}
                    ]}
                />
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '10px', alignItems: 'center', marginTop: '24px', paddingTop: '15px', borderTop: '1px solid #e0e0e0'}}>
                    {validated ? <p style={{color:'red', margin: '0 10px 0 0', fontSize: '13px'}}>Please fill all fields</p> : ""}
                    <Button variant={"success"} size={'md'} onClick={handleSubmit}>
                        Submit
                    </Button>
                    <Button variant={"secondary"} size={'md'} onClick={onClose}>
                        Cancel
                    </Button>
            </div>
        </Modal>
    )
}

export default CategoryFormComponent;